<template>
  <div class="surveillance-communication">
    <el-row type="flex" justify="end">
      <el-button @click="addNewNote()">+ New</el-button>
    </el-row>
    <el-table
    border
    :data="allNotes"
    style="width: 100%; margin-top:1em;"
    :default-sort = "{prop: 'created', order: 'descending'}"
    >
      <el-table-column
        label="Date"
        prop="created"
        width="120">
        <template scope="scope">
          {{ scope.row.created | moment('DD-MM-YYYY') }}
        </template>
      </el-table-column>
      <el-table-column
        label="Content">
        <template scope="scope">
          <div v-if="scope.row.isNew">
          <el-input            
            type="textarea"
            autosize
            placeholder="Please input"
            v-model="scope.row.content">
          </el-input>
          </div>
          <div v-else class="case-note-content">{{ scope.row.content }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="Action"
        width="150">
        <template scope="scope">
          <el-button-group>
            <el-button v-if="scope.row.isNew" @click="saveAction(scope.$index, scope.row)" size="small">
              Save
            </el-button>
            <el-button v-if="scope.row.isNew" @click="cancelAction(scope.$index, scope.row)" size="small">
              Cancel
            </el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { Loading } from 'element-ui'

export default {
  name: 'surveillance-communication',
  props: ['notes', 'caseData'],
  data: function () {
    return {
      newNotes: [],
      allNotes: []
    }
  },
  watch: {
    notes: function (value) {
      this.newNotes = []
      this.allNotes = value
      console.log(JSON.stringify(value, ' ', 2))
    },
    newNotes: function (value) {
      this.allNotes = value.concat(this.notes)
      console.log(JSON.stringify(this.allNotes, ' ', 2))
    }
  },
  methods: {
    addNewNote: function () {
      var now = new Date()
      var newNote = {
        created: now.getTime(),
        content: '',
        isNew: true
      }
      this.newNotes.splice(0, 0, newNote)
    },
    cancelAction: function (index, data) {
      console.log(JSON.stringify(data, ' ', 2))
      this.newNotes.splice(index, 1)
    },
    saveAction: function (index, data) {
      var vm = this
      var loadingInstance = Loading.service({ fullscreen: true })
      var newNote = {
        created: data.created,
        content: data.content,
        refId: this.caseData.id
      }
      console.log(JSON.stringify(newNote))
      console.log(JSON.stringify(this.caseData))

      this.$http.post(window.CONFIG.api + '/symptomDetail/new/note', newNote)
      // this.$http.post(window.CONFIG.api + '/client/new/note', newNote)
      .then(response => {
        console.log(JSON.stringify(response, 2, ' '))
        if (response.status === 200) {
          vm.caseData.notes.splice(0, 0, newNote)
          vm.newNotes.splice(index, 1)
        }
        loadingInstance.close()
      }, response => {
      // error callback
      })
    }
  },
  mounted: function () {
    console.log('mounted!')
    this.allNotes = this.notes
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// SurveillanceCommunication.vue?04da8186